// alert types
export const ALERT_TYPE_WARNING = 'warning';
export const ALERT_TYPE_INFO = 'info';
export const ALERT_TYPE_SUCCESS = 'success';
export const ALERT_TYPE_ERROR = 'error'

// alert messages
export const ALERT_GENERIC_MESSAGE = 'An error had occurred. Please contact Docma support.'
export const CAMPAIGN_PLAN_SAVED = 'Your campaign plan had been successfully saved.'
export const CAMPAIGN_PLAN_NAME_UPDATED = 'Your campaign plan name had been successfully saved.'
export const ORT_REPORT_NAME_UPDATED = 'Your ORT report name had been successfully updated.'

export const SUCCESS_USER_INVITATION_MESSAGE = 'Invitation successfully sent to user.'
export const SUCCESS_ADD_USER_MESSAGE = 'User successfully added to the organization.'
export const SUCCESS_REMOVE_USER_MESSAGE = 'User successfully removed from organization.'
export const SUCCESS_SAVE_PROJECT_ACCESS = 'Project Access successfully saved.'
export const SUCCESS_CREATE_USER_MESSAGE = 'User successfully created.'

export const PERFORMANCE_TABLE_NUMERIC_COLUMNS = [
    "last",
    "change",
    "cost_basis",
    "reach",
    "frequency",
    "daily_pl",
    "sales",
    "impressions",
    "impressions compare",
    "clicks",
    "clicks compare",
    "enrollments",
    "enrollments compare",
    "units",
    "units compare"
];

export const PERFORMANCE_TABLE_CURRENCY_COLUMNS = [
    "cpe",
    "cpe compare",
    "roi",
    "roi compare",
    "spend",
    "spend compare",
    "sales_attribution",
    "sales_attribution compare",
    "cpm",
    "cpm compare",
    "avg_cpm",
    "cpc",
    "avg_cpc",
    "cpu",
    'volume',
    'roas'
];

export const PERFORMANCE_TABLE_PERCENTAGE_COLUMNS = [
    "roi change",
    "spend change",
    "impressions change",
    "sales_attribution change",
    "clicks change",
    "cpm change",
    "cpu change",
    "units change",
    "ctr",
    "avg_ctr",
    "cpe change",
    "enrollments change"
];

export const GREEN_HEX_CODE = '#00D100';
export const RED_HEX_CODE = '#EE4B2B';

export const DELAY = (ms) => new Promise((res) => setTimeout(res, ms));

export const EXPORT_DELAY_IN_MS = 2000;

export const SUBTRACT_DATES = (date1, date2) => {
    const oneDay = 24 * 60 * 60 * 1000; // milliseconds in one day
    const diffInMilliseconds = date1.getTime() - date2.getTime();
    return Math.round(diffInMilliseconds / oneDay); // Convert milliseconds to days
};

export const ADD_DAYS = (date, days) => {
    const newDate = new Date(date);
    newDate.setDate(date.getDate() + days);
    return newDate;
};